import { Component, inject, input, model } from '@angular/core';

import { I18nService } from '../../../services/i18n.service';
import { UiService } from '../../../services/ui.service';
import { NzSwitchComponent } from 'ng-zorro-antd/switch';
import { FormsModule } from '@angular/forms';
@Component({
  selector: 'app-email-toggle',
  templateUrl: './email-toggle.html',
  styleUrls: ['./email-toggle.scss'],
  imports: [NzSwitchComponent, FormsModule],
})
export class EmailToggleComponent {
  settings = input.required<any>();
  userEmail = input<string>('');
  loading = input<boolean>(false);
  allNotifications = input<boolean>(false);
  value = model<boolean>(false);
  public ui = inject(UiService);
  public i18n = inject(I18nService);

  toggleValue() {
    this.value.update((current) => !current);
  }
}
